import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { URLS } from '../config/urls';
import { WorkflowState } from '../state/state.state';
import { AlertService } from 'projects/shared-new/src/lib/services-new/alert.service';
import { StateService } from '../state.service';
import { FileStatus, Workflow } from '../types/types';
import { updateWorkflow } from '../state/state.actions';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor(private store: Store<{ workflow: WorkflowState }>) {}

  private httpClient = inject(HttpClient);
  private alertService = inject(AlertService);
  private stateService = inject(StateService);

  uploadFile(file: File, workflow: Workflow): void {
    const formData = new FormData();
    formData.append('file', file);
    this.httpClient
      .post<FileStatus>(`${URLS.UPLOAD_FILE}?workflow_id=${workflow.uid}`, formData)
      .subscribe({
        next: (response) => {
          response.name = file.name;
          response.size = String(file.size);
          this.stateService.getProcessStatus(response.uid);
          this.stateService.setFileStatus(response, workflow);
        },
        error: (error) => {
          this.alertService.error(
            'Oops! It seems like there was an issue uploading your file. Please try again.',
          );
        },
      });
  }

  deleteFile(file: FileStatus, workflow: Workflow): void {
    const regex = /\/(.*?)\./;
    const match = regex.exec(file.result);
    if (match && match[1]) {
      this.httpClient
        .delete<string>(`${URLS.DELETE_FILE}/${match[1]}`)
        .subscribe({
          error: (error) => {
            this.alertService.error(
              'Oops! It seems like there was an issue uploading your file. Please try again.',
            );
          },
        });
    }
  }
}
